

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject, throwError } from "rxjs";
import { tap, catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";

@Injectable({providedIn:'root'})
export class AuthService{
    loggedIn$ = new BehaviorSubject(false);
    lid: number = 214601;
    lidSub= new Subject<number>();
    constructor(private httpClient: HttpClient) {
        this.isLoggedIn() ? this.loggedIn$.next(true) : this.loggedIn$.next(false);
    }

    getToken() {
        return localStorage.getItem('token') || '';
    }

    private parseJwt(token: string): Record<string, any> | null {
        try {
            const payload = token.split('.')[1];
            if (!payload) return null;
            const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
            return JSON.parse(decoded);
        } catch {
            console.warn('[AuthService] Could not parse JWT payload');
            return null;
        }
    }

    getUserId(): number {
        const claims = this.parseJwt(this.getToken());
        if (!claims) return 0;
        // Keycloak uses 'sub' (UUID string); fallback to numeric 'userId' / 'id' if present
        const raw = claims['userId'] ?? claims['id'] ?? claims['sub'] ?? 0;
        const parsed = Number(raw);
        return isNaN(parsed) ? 0 : parsed;
    }

    getUserEmail(): string {
        const claims = this.parseJwt(this.getToken());
        return claims?.['email'] ?? '';
    }

    isLoggedIn() {
        let token = localStorage.getItem('token');
        const isLoggedIn = !!token && token !== 'null';
        return isLoggedIn
    }
    login(loginForm:{password:string, email:string}): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Bearer {{token}}'
        });

        let options = {
            headers: headers,
            // params:loginForm
        }
        return this.httpClient.post(`${environment.loginApi}keycloak/login?password=${loginForm.password}&email=${loginForm.email}`, null, options).pipe(
            tap((response: any) => {
                if (response.token) {
                    localStorage.setItem('token', response.token);
                    this.loggedIn$.next(true);
                }
            })
        );
    }

    registration(loginForm:{ email:string, password:string}): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Bearer {{token}}'
        });

        let options = {
            headers: headers
        }
        return this.httpClient.post(`${environment.loginApi}keycloak/register?password=${loginForm.password}&email=${loginForm.email}`, null, options).pipe(
            tap((response: any) => {
                if (response.token) {
                    localStorage.setItem('token', response.token);
                    this.loggedIn$.next(true);
                }
            }),
            catchError(error => {
                if (error.status === 409) {
                    return throwError(() => ({ status: 409, message: 'USER_EXISTS' }));
                } else {
                    return throwError(() => ({status:error.status, message:error.message}));
                }
            })
        );
    }

    logout(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (this.isLoggedIn()) {
                localStorage.removeItem('token');
                this.loggedIn$.next(false);
                resolve(null);
                this.lidSub.next(214601);
            }
        });
    }
}